import React, { useLayoutEffect, useEffect, useRef, useState } from 'react';
import { select } from 'd3';
import * as d3 from 'd3';
import './style.css';

const HorizontalBarChart = (props) => {
  const alphabet = props?.data;
  const chartID = props?.id;
  const chartRef = useRef(null);
  const ref = useRef(null);
  const [svgWidth, getSvgWidth] = useState();
  const [yAxisTitle, setYAxisTitle] = useState("");

  const [screenSize, getDimension] = useState({
    dynamicWidth: window.innerWidth
  });
  const setDimension = () => {
    getDimension({
      dynamicWidth: window.innerWidth
    })
  };
  const newArr = alphabet[0]?.values;

  useEffect(() => {
    setYAxisTitle(alphabet[0]?.name)
  },[alphabet]);

  useEffect(() => {
    window.addEventListener('resize', setDimension);
    
    return(() => {
      window.removeEventListener('resize', setDimension);
    })
  }, [screenSize]);
  
  useEffect(() => {
    setTimeout(() => {
      getSvgWidth(ref?.current?.offsetWidth);
    }, 100);
  }, [screenSize]);
  
  useEffect(() => {
    d3.select(chartRef.current).select('svg').remove();

    const container = d3.select(ref.current);
    const width = container.node().getBoundingClientRect().width || svgWidth;
    const marginTop = 15;
    const marginRight = 20;
    const marginBottom = 30;
    const marginLeft = 20;
    const height = 320;
    const horizontalWidth = newArr.length === 1 
    ? width - marginLeft - marginRight // full width for single bar
    : width - marginLeft - marginRight;
    // Create the scales.
    const x = d3
      .scaleLinear()
      .domain([0, d3.max(newArr, (d) => d.value)])
      .range([marginLeft, width - marginRight]);

    const y = d3
      .scaleBand()
      .domain(d3.sort(newArr, (d) => -d.value).map((d) => d.key))
      .rangeRound([marginTop, height - marginBottom])
      .padding(0.1);

    // Create the SVG container.
    const svg = select(chartRef.current)
      .append('svg')
      .attr('class', "barChart")
      .attr('width', width)
      .attr('height', height)
      .attr('viewBox', [0, 0, width, height])
      .attr('style', 'max-width: 100%; height: auto; font: 10px sans-serif;')
      .on('mouseover', (d, i) => {
        svg.selectAll('.react-bar-div').style('opacity', '.5');
        svg.selectAll('.bar-text').style('opacity', '.5');
      })
      .on('mouseout', (d, i) => {
        svg.selectAll('.react-bar-div').style('opacity', '1');
        svg.selectAll('.bar-text').style('opacity', '1');
      });

    // Append a rect for each key.
    svg
      .append('g')
      .attr('id', 'react-div')
      .attr('fill', '#878787')
      .selectAll()
      .data(newArr)
      .join('rect')
      .attr('class', 'react-bar-div')
      .attr('cursor', 'pointer')
      .attr('x', newArr.length === 1 ? marginLeft : x(0))
      .attr('y', (d) => y(d.key) + 12)
      .attr('width', (d) => x(d.value) - x(0))
      .attr('id', (d, i) => chartID + 'reactbar' + i)
      .attr('data-id', (d, i) => i)
      .attr('height', y.bandwidth() - 18)
      .on('click', (d, i) => {
      //  console.log('bar clicked', d, i);
      })
      .on('mouseover', function (d, i) {
        const bar = '#'+ chartID +'reactbar' + d.target.dataset.id;
        const text = '#' + chartID + 'bartext' + d.target.dataset.id;;
        d3.select(bar).classed('active', true);
        d3.select(text).classed('active', true);
      })
      .on('mouseout', function (d, i) {
        const bar = '#'+ chartID +'reactbar' + d.target.dataset.id;
        const text = '#' + chartID + 'bartext' + d.target.dataset.id;;
        d3.select(bar).classed('active', false);
        d3.select(text).classed('active', false);
      })
      .append('title')
      .text((d) => d.key);

    svg
      .append('g')
      .attr('id', 'react-div')
      .attr('fill', 'transparent')
      .selectAll()
      .data(newArr)
      .join('rect')
      .attr('class', 'react-bar-div')
      .attr('cursor', 'pointer')
      .attr('x', newArr.length === 1 ? marginLeft : x(0))
      .attr('y', (d) => y(d.key) - 5)
      .attr('width', horizontalWidth)
      .attr('id', (d, i) => chartID + 'reactbar' + i)
      .attr('data-id', (d, i) => i)
      .attr('height', 40)
      .on('click', (d, i) => {
       // console.log('bar clicked', d, i);
      })
      .on('mouseover', function (d, i) {
        const bar = '#'+ chartID +'reactbar' + d.target.dataset.id;
        const text = '#' + chartID + 'bartext' + d.target.dataset.id;;
        d3.select(bar).classed('active', true);
        d3.select(text).classed('active', true);
      })
      .on('mouseout', function (d, i) {
        const bar = '#'+ chartID +'reactbar' + d.target.dataset.id;
        const text = '#' + chartID + 'bartext' + d.target.dataset.id;;
        d3.select(bar).classed('active', false);
        d3.select(text).classed('active', false);
      })
      .append('title')
      .text((d) => d.key);

    // Append a label for each key.
    svg
      .append('g')
      .attr('fill', '#242424')
      .attr('text-anchor', 'start')
      .attr('font-family', '"Ericsson Hilda",Helvetica,sans-serif')
      .attr('font-size', '14px')
      .selectAll()
      .data(newArr)
      .join('text')
      .attr('class', 'bar-text')
      .attr('x', newArr.length === 1 ? marginLeft + 5 : x(10))
      .attr('id', (d, i) => chartID + 'bartext' + i)
      .attr('data-id', (d, i) => i)
      .attr('y', (d, i) => y(d.key) + 4)
      .attr('dy', '0.35em')
      .attr('dx', +1)
      .text((d) => d.key + ' ' + d.value)
      .attr('cursor', 'pointer')
      .on('click', (d, i) => {
       // console.log('Text clicked', d, i);
      })
      .on('mouseover', function (d, i) {
        const bar = '#'+ chartID +'reactbar' + d.target.dataset.id;
        const text = '#' + chartID + 'bartext' + d.target.dataset.id;
        d3.select(bar).classed('active', true);
        d3.select(text).classed('active', true);
      })
      .on('mouseout', function (d, i) {
        const bar = '#'+ chartID +'reactbar' + d.target.dataset.id;
        const text = '#' + chartID + 'bartext' + d.target.dataset.id;;
        d3.select(bar).classed('active', false);
        d3.select(text).classed('active', false);
      })
      .call((text) =>
        text
          .filter((d) => x(d.value) - x(0) < 20)
          .attr('dx', +1)
          .attr('fill', '#242424')
          .attr('text-anchor', 'start')
      );
    svg
      .append('text')
      .attr('x', width)
      .attr('y', 319)
      .text(yAxisTitle || 'count')
      .attr('text-anchor', 'end');

    // Create the axes.
    svg
      .append('g')
      .attr('transform', `translate(0,${marginBottom + height - 60})`)
      .attr('stroke-dasharray', '2')
      .call(d3.axisBottom(x).tickSizeOuter(1).tickSize(50 - height).ticks(3))
      .call((g) => g.select('.domain').remove());

    svg
      .append('g')
      .attr('transform', `translate(${marginLeft},0)`)
      .call(d3.axisLeft(y).tickSizeOuter(1))
      .call((g) => g.selectAll('.tick Line, .tick Text').remove());
  }, [alphabet || svgWidth]);

  return (
    <div className='w-100' ref={ref}>
      <div ref={chartRef} className='w-100'></div>
    </div>
  );
};

export default HorizontalBarChart;
